var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
// @ts-ignore
import { getElementType } from 'semantic-ui-react/dist/commonjs/lib';
export const SkeletonImage = (props) => {
    const { size, animated = true, circular, rectangular, className } = props, rest = __rest(props, ["size", "animated", "circular", "rectangular", "className"]);
    const classes = cn(className, 'skeleton-image', 'ui', 'skeleton', {
        [size]: !!size,
        animation: animated,
        circular,
        rectangular,
    });
    const ElementType = getElementType(SkeletonImage, props);
    return React.createElement(ElementType, Object.assign({ className: classes }, rest));
};
SkeletonImage.displayName = 'SkeletonImage';
export default SkeletonImage;
//# sourceMappingURL=SkeletonImage.js.map